<template>
  <div class="upload-file" @click="handleClick">
    <input ref="input" type="file" :accept="accept" @change="uploadFile" />
    <slot>
      <div class="default-add-file">
        <!-- <Icon type="ios-cloud-upload" size="52" style="color: #3878FF"></Icon> -->
        <i class="el-icon-folder-add" style="color: #3878FF;font-size:52px"></i>
        <p class="note">{{ note }}</p>
      </div>
    </slot>
  </div>
</template>

<script>
import OSS from "ali-oss";

export default {
  props: {
    // 文件目录
    dir: {
      type: String,
      required: true
    },
    // 该文件是否需要认证才能访问 [PUBLIC  PRIVATE]
    type: {
      type: String,
      default: "public"
    },
    accept: String,
    // 文件限制大小，单位kb
    maxSize: Number,
    note: {
      type: String,
      default: "点击上传文件"
    }
  },
  data() {
    return {
      // baseStorageUrl: process.env.VUE_APP_UPLOAD_URL
    };
  },
  methods: {
    handleClick() {
      this.$refs.input.click();
    },
    // 文件上传
    uploadFile(event) {
      const file = event.target.files[0];
      console.log(file);
      if (this.maxSize && file.size > this.maxSize * 1024 * 1024) {
        this.$Message.warning(`文件大小超过${this.maxSize}MB!`);
        return;
      }
      this.requestOss(file, this.dir, this.type);
    },
    async requestOss(file, dir, type) {
      // 文件上传提示
      let loadingPrompt = this.$Message.loading({
        content: "文件上传中···",
        duration: 0
      });

      const res = await this.$api.storage.ApplySecurityToken();
      let data = res.data;

      const store = OSS({
        region: data.region,
        accessKeyId: data.accessKeyId,
        accessKeySecret: data.accessKeySecret,
        stsToken: data.securityToken,
        bucket: data.bucket
      });

      let fileName = data.dir + "/" + new Date().getTime() + "/" + file.name;

      // 生成文件访问路径
      // const fileObj = this.$util.tools.formatFileObj(file.name);
      // const fileName = `${token.data.dir}/${this.$util.tools.getUniqueID(
      //   fileObj.name
      // )}${fileObj.suffix}`;

      // web直传至阿里云  .multipartUpload(fileName, file)
      store
        .put(fileName, file)
        .then(res => {
          // res.url = this.baseStorageUrl + '/' + fileName;

          res.url = res.url.replace("http:", "https:");
          this.$emit("on-success", {
            // absolutePath: this.baseStorageUrl + res.name,
            absolutePath: res.url,
            relativePath: res.name,
            name: file.name,
            file: file
          }); // 传入绝对路径和相对路径
        })
        .catch(err => {
          console.error(err);
          this.$Message.error("上传出错！");
        })
        .finally(() => {
          loadingPrompt();
          this.$refs.input.value = ""; // 图像上传后清空，因为监听的onchange事件
        });
    }
  }
};
</script>

<style lang="less" scoped>
.upload-file {
  position: relative;
  text-align: center;
  cursor: pointer;
  input[type="file"] {
    display: none;
  }
  .note {
    color: #92959A;
  }
  .default-add-file {
    border: 1px dashed #3878FF;
    padding: 20px 20px;
  }
}
</style>
